import {
  ILoaderContainerProps,
  loaderContainerFactory,
} from 'affiny-core/modules/asynchronousState/containers/loaderContainerFactory';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import {
  isBlackListEmpty,
  selectBlackList,
} from 'affiny-core/redux/selectors/blacklistSelectors';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { Dispatch } from 'redux';
import { IRootState } from '../../state';
import { blacklistActions } from '../actions';

const mapStateToProps = (state: IRootState) => ({
  blackList: selectBlackList(state),
  isBlackListEmpty: isBlackListEmpty(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getBlackList: () => dispatch(blacklistActions.getBlacklist()),
});

export type TBlackListContainerProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  ILoaderContainerProps;

export const hocLifecycle = lifecycle<TBlackListContainerProps, {}>({
  componentDidMount() {
    this.props.getBlackList();
  },
});

export const blackListContainerFactory = compose(
  connect(mapStateToProps, mapDispatchToProps),
  loaderContainerFactory(EAsyncEventTypes.GET_BLACKLIST),
  hocLifecycle
);
